/**
 * 中国区号
 */
export const getChinaCode = () => {
    return '+86';
};

/**
 * 根据带区号的手机号获取其中手机号部分
 * 比如由"+86-18346"获取"18346"
 *
 * @param value 带区号的手机号
 * @param phoneDelimiter 手机号分隔符
 */
export const getPhoneByValue = (value: string, phoneDelimiter = '-') => {
    if (value) {
        const phoneDelimiterIndex = value.indexOf(phoneDelimiter);
        if (phoneDelimiterIndex >= 0) {
            return value.slice(phoneDelimiterIndex + 1);
        }
        return value;
    }
    return '';
};
